module.exports = __webpack_public_path__ + "static/media/completed.463116f7.svg";